import {JsonObject, JsonProperty} from 'json2typescript';
import {Answer} from '../answer';
import {ExecutionResult} from './executionResult';
import {DynamicData} from './DynamicData';
import {TargetedRespondent} from './targetedRespondent';




@JsonObject('DynamicDataResponse')
export class DynamicDataResponse {

    @JsonProperty('target_respondent',TargetedRespondent,true)
    _target_respondent:TargetedRespondent = null;

    @JsonProperty('answers_result',ExecutionResult,true)
    _answers_result = null;

    @JsonProperty('dynamic_values_result',ExecutionResult,true)
    _dynamic_values_result = null;

    // TODO: Un-necessary since any regular answer would show up as usual
    @JsonProperty('answers_list',[Answer],true)
    _answers_list:Answer[] = [];

    @JsonProperty('dynamic_values_list',[DynamicData],true)
    _dynamic_values_list:DynamicData[] = [];


   /* getTarget_respondent(): Respondent {
        return this._target_respondent;
    }

    getAnswers_result(): any {
        return this._answers_result;
    }

    getDynamic_values_result(): any {
        return this._dynamic_values_result;
    }

    getAnswers_list(): Answer[] {
        return this._answers_list;
    }

    getDynamic_values_list(): DynamicData[] {
        return this._dynamic_values_list;
    }*/
}
